<template>
  <div class="page-wrapper">
    <div class="container">
      <div class="row nav-container">
        <ul>
          <li><a href="#/admin/home/">메인</a></li>
          <li><a class="active" href="#/admin/checkin/">체크인</a></li>
          <li><a href="#/admin/settings/">세팅</a></li>
          <li><a href="#/admin/customers/">업체</a></li>
          <li><a href="#/admin/forwarders/">파트너</a></li>
          <li><a href="#/admin/users/">사용자</a></li>
          <li v-on:click="showFixView"><a style="color:white;">스캐너고장</a></li>
          <li>
            <div class="logout" v-on:click="logout">로그아웃 v{{version}}</div>
          </li>
        </ul>
      </div>
    </div>
    <audio id="audio" src="@/assets/images/Bike-horn.mp3"/>


    <div class="fullscreen qrreader-container hide section-container" id="qrReader">
      <div class="container">
        <div class="row">
          <div class="col-6">

          </div>
          <div class="col-6">
            <h2><span v-on:click="stopScanner"><i class="fas fa-times"></i> 닫기</span></h2>
          </div>
        </div>
      </div>
      <div ref="quagga" class="camera"/>
      <div class="container work-list-container">
        <transition-group name="slide" tag="p">
          <p v-for="(item, index) in workList" style="color:white;" v-bind:key="item.id">{{item.awb}} {{(item.measured_weight/100).toFixed(2)}}kg</p>
        </transition-group>
      </div>
    </div>
    <div class="fullscreen qrreader-container hide section-container" id="qrReader2" data-type="0">
      <h2 id="qrcode-reader-view-title">QR 코드</h2>
      <p>QR코드를 스캔하세요</p>
      <div class="cam-container">
        <qrcode-stream class="hide" @decode="onDecode" v-if="qrReaderOn"></qrcode-stream>
      </div>
      <div class="container section-container">
        <div class="row">
          <div class="col-8">
            <input type="text" class="form-control" name="code" placeholder="송장번호 입력" v-model="manualCode"/>
          </div>
          <div class="col-4">
            <button type="button" class="form-control btn btn-secondary" v-on:click="onCodeEntered()">입력</button>
          </div>
        </div>
      </div>

      <div class="container section-container">
        <div class="row">
          <div class="col-12">
            <button type="button" class="form-control btn btn-secondary" v-on:click="closeReader()">닫기</button>
          </div>
        </div>
      </div>
    </div>
    <div class="container panel-container">
      <div class="row h-100">
        <div class="col-3 h-100">
          <div style="height: 100%; width: 100%; overflow-y: scroll">
            <div style="height:40px; line-height: 40px; width: 100%; background-color: black; color:white; text-align: center;">
              <strong>자주쓰는 무게</strong>
            </div>
            <ul class="list-group">
              <li class="list-group-item" v-for="(weight, index) in weightList" v-on:click="setWeightItem(weight)">
                {{weight}} <span v-on:click.stop="removeWeightItem(index)" style="float:right"><i class="fas fa-trash"></i></span>
              </li>
              <li class="list-group-item">
                <input type="number" id="new-weight"/> <span v-on:click="addWeightItem" style="float:right"><i class="fas fa-plus"></i></span>
              </li>
            </ul>
          </div>
<!--          <div style="height: 70%; min-height: 300px; width: 100%; overflow-y: scroll">-->
<!--            <div style="height:40px; line-height: 40px; width: 100%; background-color: black; color:white; text-align: center; position: relative">-->
<!--              <strong>오늘 처리 송장</strong>-->
<!--              <div v-on:click="clearTodayItems" style="position: absolute; right:0; top: 0; height: 40px; line-height: 40px; width:40px;"><i class="fas fa-trash"></i></div>-->
<!--            </div>-->
<!--            <ul class="list-group">-->
<!--              <li class="list-group-item" v-for="awb in todayList">-->
<!--                {{awb}}-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
        </div>
        <div class="col-9">
          <div class="container section-container" v-if="fixView == true">
            <div class="row">
              <div class="col-6">
                <h4>Step 1</h4>
                <p>아래의 QRCode를 스캔해주세요</p>
                <img class="fix-qr-code" src="/static/img/scanner_factory_reset.png" />
              </div>
              <div class="col-6">
                <h4>Step 2</h4>
                <p>1. 화면뒤 dongle을 분리</p>
                <p>2. Dongle을 다시 꽂아주세요</p>
                <p>3. 아래의 QR code를 스캔해주세요</p>
                <img class="fix-qr-code" src="/static/img/scanner_pairing.png" />
              </div>
            </div>
            <div class="row section-container">
              <div class="col-12">
                <button class="btn btn-secondary" v-on:click="closeFixView">닫기</button>
              </div>
            </div>
          </div>
          <div class="container section-container" v-if="fixView ==false">
            <div class="row">
              <div class="col-3">
                <button type="button" class="btn btn-primary" v-on:click="startReader()">카메라</button>

                <button type="button" class="btn btn-secondary" v-on:click="showFixView">스캐너고장</button>
              </div>
              <div class="col-3">
                <div class="image-btn-container" v-if="editItem != false" v-on:click="printItem()">
                  <div class="image-btn"
                       :style="{backgroundImage: 'url(' + require('@/assets/images/ic_print.png') + ')'}"/>
                  송장 출력
                </div>
              </div>
<!--              <label class="col-3 form-control text-right"></label>-->
              <div class="col-6">
                <div style="width:100%; display: flex; height: 40px; line-height: 40px; text-align: right;">
                고정무게:
                <input type="number" class="form-control" style="margin-left:10px;width: 130px;" v-model="purposeWeight"/>
                <button class="btn btn-danger" style="margin-left:10px;" v-on:click="clearPurposeWeight"><i class="fas fa-times"></i></button>
                </div>
              </div>
            </div>
            <div class="row" style="display: none;">
              <div class="col-12">
          <textarea class="form-control" v-model="content">

          </textarea>
              </div>
            </div>
          </div>
          <div class="container" v-if="editItem != false">
            <div class="row section-container">
              <div class="col-6">송장 [{{editItem.awb}}]</div>
              <div class="col-6">[{{editItem.code}}]</div>
            </div>
            <div class="row section-container">
              <div class="col-6">
                <div class="container">

                  <div class="form-group row">
                    <label class="col-4 form-control text-right">가로 (폭, Width)</label>
                    <div class="col-8">
                      <input type="number" class="form-control" @focus="editItem.volume_x = ''" v-model="editItem.volume_x"
                             v-on:change="onVolumeEntered()" v-bind:class="{'warning-item': editItem.volume_x < 0}"/>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-4  form-control text-right">높이 (Height)</label>
                    <div class="col-8">
                      <input type="number" class="form-control" @focus="editItem.volume_y = ''" v-model="editItem.volume_y"
                             v-on:change="onVolumeEntered()" v-bind:class="{'warning-item': editItem.volume_y < 0}"/>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-4 form-control text-right">세로 (깊이, Depth)</label>
                    <div class="col-8">
                      <input type="number" class="form-control" @focus="editItem.volume_z = ''" v-model="editItem.volume_z"
                             v-on:change="onVolumeEntered()" v-bind:class="{'warning-item': editItem.volume_z < 0}"/>
                    </div>
                  </div>

                  <div class="form-group row">
                    <div class="col-12">
                      <button type="button" class="form-control btn btn-secondary big-button" v-on:click="getDistance">부피 + 무게</button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-6">
                <div class="container">
                  <div class="form-group row">
                    <label class="col-4 form-control text-right">VW</label>
                    <div class="col-8 col-md-4">
                      <input type="number" class="form-control" v-model="editItem.volume_weight/100"   v-bind:class="{'warning-item': editItem.volume_weight < 0}" disabled/>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-4 form-control text-right">GW</label>
                    <div class="col-8 col-md-4">
                      <input type="number" class="form-control" @focus="editItem.measured_weight = ''"
                             v-model="editItem.measured_weight" v-on:change="onVolumeEntered()"/>
                    </div>

                  </div>
                  <div class="form-group row">
                    <label class="col-4 form-control text-right">CW</label>
                    <div class="col-8 col-md-4">
                      <input type="number" class="form-control" v-model="editItem.weight/100" disabled/>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-12 col-md-6">
                      <button type="button" v-if="size.xr > 0 && size.y > 0 && size.z > 0" class="form-control btn btn-secondary big-button" v-on:click="getWeightKeepVolume">이전크기 + 실무게 </button>
                    </div>
                    <div class="col-12 col-md-6">
                      <button type="button" class="form-control btn btn-secondary big-button" v-on:click="getWeight">실무게만</button>
                    </div>
                  </div>
                </div>
              </div>

              <hr>
              <div class="col-12">
                <div class="container">
                  <div class="form-group row">
                    <label class="col-4 form-control text-right">기본요금</label>
                    <div class="col-8 col-md-4">
                      <input type="number" class="form-control" @focus="editItem.base_price = ''"
                             v-model="editItem.base_price" v-on:change="onVolumeEntered()"/>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-4 form-control text-right">추가요금</label>
                    <div class="col-8 col-md-4">
                      <input type="number" class="form-control" @focus="editItem.add_price = ''" v-model="editItem.add_price"
                             v-on:change="onVolumeEntered()"/>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-4 form-control text-right">최종요금</label>
                    <div class="col-8 col-md-4">
                      <h3>£{{(editItem.price/100).toFixed(2)}}</h3>
                    </div>
                  </div>
                </div>
              </div>


            </div>

            <div class="row section-container">
              <div class="col-6">
                <button type="button" class="btn btn-primary form-control big-button" v-on:click="closeItem()">CLOSE</button>
              </div>
              <div class="col-6">
                <button type="button" class="btn btn-primary form-control big-button" v-on:click="updateItem()">UPDATE</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="progressView" v-if="showProgress==true">
      <div class="center-container container">
        <div class="row">
          <div class="col-4">
            <div class="loader"></div>
          </div>
          <div class="col-8">
            <div class="center-container text-left">
              {{progressMessage}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="spinner-container" v-if="isLoading">
      <div class="spinnermedium">
        <span class="bgtopl"><span class="highlighttopl"></span></span>
        <span class="bgtopr"><span class="highlighttopr"></span></span>
        <span class="bottomrow">
          <span class="bgbtml"><span class="highlightbtml"></span></span>
          <span class="bgbtmr"><span class="highlightbtmr"></span></span>
        </span>
      </div>
    </div>
<!--    <div class=""-->
    <v-dialog/>
  </div>
</template>

<script>
  import {getVersion, millisToDate, playSound, playWrongSound} from "../api/Utils";

    require('@/assets/css/styles.css')

    import Router from '../router';
    import VModal from '../router';
    import axios from 'axios';
    import Quagga from 'quagga'; // ES6
    import {getDepotCode, requestPrintLabel} from '../api/parcel'

    export default {
        name: 'Home',

        data() {
            return {
                version:'',
                msg: 'CheckIn',
                customers: [],
                manualCode: '',
                qrReaderOn: false,
                editItem: false,
                showProgress: false,
                progressMessage: 'Test',
                isLoading: false,
                inputList: [],
                barCode: '',
                content: '',

                size: {
                    x: 0,
                    xr: 0,
                    y: 0,
                    z: 0
                },

                purposeWeight:0,


                readerSize: {
                    width: 640,
                    height: 480
                },
                detecteds: [],
                data:null,
                workList:[],

                fixView: false,

                weightList:[],
                todayList:[],

            }
        },
        components: {

        },
        created: function () {
            this.$data.version = getVersion();
            if(localStorage.getItem('id') == undefined || localStorage.getItem('id') == null || localStorage.getItem('id') === '') {
                Router.push('/admin');
                return;
            }
            document.addEventListener("backbutton", this.backHandler, false);
            this.$data.user = {
                id: localStorage.getItem('id'),
            }
            this.audio = document.getElementById('audio');

        },
        beforeDestroy() {
            registerBackKeyHandler(false);
            window.removeEventListener('keydown',this.keydownHandler);
        },
        mounted: function () {
            registerBackKeyHandler(false);
            registerBackKeyHandler(this.backHandler);
            this.getCustomerList();
            //registerBackKeyHandler(this.backHandler);
            console.log("register key downhandler s");
            window.removeEventListener('keydown',this.keydownHandler);
            window.addEventListener('keydown', this.keydownHandler);
            this.loadWeightItems();
            this.loadTodayItems();
        },
        methods: {
            keydownHandler: function(e) {
              console.log("Key input " + e.key);
              console.log("good");
              this.keyHandler(e.key);
            },
            closeFixView: function() {
                this.$data.fixView = false;
            },
            showFixView: function() {
                this.$data.fixView = true;
            },
            playEffect: function() {
                //this.audio.play();
                var audio = new Audio("/Bike-horn.mp3");
                audio.play();
            },
            backHandler: function () {
                console.log("Admin Main back pressed");
                if (this.$data.qrReaderOn == true) {
                    this.$data.qrReaderOn = false;
                }
                if (!$("#qrReader").hasClass("hide")) {
                    $("#qrReader").addClass("hide");
                }

            },
            getTracking: function (awb) {
                this.$data.content = '';
                //var url = process.env.APP_URL + 'api/dw_tracking.php?shipping_number=' + awb;
                var url = 'https://api.utasco.net/' + 'api/dw_tracking.php?shipping_number=' + awb;
                axios.get(url)
                    .then(response => {
                        console.log(response);
                        var data = response.data;
                        if (data.success) {
                            var url = 'http://system.daewoonglobal.com/invoice/invoice_view.asp?menu_idx=10&loading_no=' + data.loadingNumber;
                            window.open(url);
                        }
                    })
                    .catch(error => {
                        console.log("Error " + error);
                    })
            },
            loadWeightItems: function() {

              console.log("weight list: " + localStorage.getItem("weight_list"));
              if(localStorage.getItem("weight_list") != null && localStorage.getItem("weight_list").length > 0) {
                this.$data.weightList = JSON.parse(localStorage.getItem("weight_list"));
              }
            },
            clearPurposeWeight: function() {
              this.$data.purposeWeight = 0;
            },
            setWeightItem: function(weight) {
              this.$data.purposeWeight = parseFloat(weight);
            },
            removeWeightItem: function(index) {
              this.$data.weightList.splice(index, 1);
              localStorage.setItem("weight_list", JSON.stringify(this.$data.weightList));
            },
            addWeightItem: function() {

              let newWeight = document.getElementById("new-weight").value;
              if(newWeight == null || newWeight == '') {
                window.alert("Wrong Weight");
                return;
              }

              newWeight = parseFloat(newWeight);
              this.$data.weightList.push(newWeight);
              localStorage.setItem("weight_list", JSON.stringify(this.$data.weightList));
              document.getElementById("new-weight").value = "";
            },

            clearTodayItems: function() {
              this.$data.todayList = [];
              localStorage.removeItem('today-list')
            },
            loadTodayItems: function() {
              this.$data.todayList = [];
              if(localStorage.getItem('today-list') != null && localStorage.getItem('today-list').length > 0) {
                this.$data.todayList = JSON.parse(localStorage.getItem('today-list'));
              }
            },
            addTodayItem: function(awb) {
              this.$data.todayList.push(awb);
              localStorage.setItem('today-list', JSON.stringify(this.$data.todayList));
            },
            test: function () {
                console.log(this.$data.content);
                var lines = this.$data.content.split('\n');
                var data = {};
                for (var i = 0; i < lines.length; i++) {
                    //console.log("Line " + i  + " : " + lines[i]);
                    var line = lines[i];
                    if (lines[i].startsWith("Station")) {
                        console.log("Line " + i + " : " + lines[i]);
                        var words = line.split('\t');
                        console.log("Station Code " + words);
                        data['code'] = words[1];
                        //data['userName'] = words[3];
                    } else if (lines[i].startsWith('Loading No.')) {
                        data['dispatch_date'] = lines[i].split('\t')[3];
                    } else if (lines[i].startsWith('Shipping No.')) {
                        data['awb'] = lines[i].split('\t')[1];
                    } else if (lines[i].startsWith('고객명 *')) {
                        console.log("고객명 " + i + " : " + lines[i]);
                        var words = line.split('\t');
                        console.log(words);
                        data['receiver'] = words[1];
                        data['receiver_contact'] = words[3];
                        console.log(lines[i + 1].split('\t'));

                    } else if (lines[i].startsWith('주소 *')) {
                        data['address_1'] = lines[i].split('\t')[1];
                    } else if (lines[i].startsWith('전화번호')) {
                        console.log("전화번호 " + i + " : " + lines[i]);
                        var words = line.split('\t');
                        data['post_code'] = words[3];
                        console.log(words);
                    } else if (lines[i].startsWith('Social')) {
                        console.log("Social ID " + i + " : " + lines[i]);
                        var words = line.split('\t');
                        console.log(words);
                        //data['socialId'] = words[1];
                        data['custom_number'] = words[3];
                    } else if (lines[i].includes('Description 정보')) {
                        var items = [];
                        var totalValue = 0;
                        for (i += 2; i < lines[i].length; i++) {
                            if (lines[i].includes('Weight 정보')) {
                                break;
                            }
                            console.log("*Item ");
                            console.log(lines[i].split('\t'));
                            var words = lines[i].split('\t');
                            var item = {
                                product: words[4],
                                origin_country: words[1],
                                brand: words[2],
                                hs_code: parseInt(words[3].replace('[', '').replace(']', '')),
                                amount: parseInt(words[5]),
                                value: parseInt(words[6]),
                                liquid: 0
                            };
                            totalValue += parseInt(words[6]);
                            items.push(item);
                        }
                        data['value'] = totalValue;
                        data['list'] = JSON.stringify(items);
                    }
                }

                data['seller_type'] = 2;
                data['custom_type'] = '목';
                data['trade_type'] = 'A';
                console.log(data);
                var url = process.env.APP_URL + 'api/create_dw_item.php';
                var self = this;
                axios.post(url, JSON.stringify(data))
                    .then(response => {
                        console.log(response);
                        if (response.data.success == true) {
                            self.$data.editItem = response.data.item;
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },
            logout: function () {
                var self = this;
                this.$modal.show('dialog', {
                    //title: '로그아웃',
                    text: '로그아웃 하시겠습니까?',
                    buttons: [
                        {
                            title: '아니요',
                            handler: () => {
                                self.$modal.hide('dialog');

                            }
                        },
                        {
                            title: '로그아웃',
                            handler: () => {
                                self.$modal.hide('dialog');
                                self.onLogoutConfirmed();
                            }
                        },

                    ]

                });
            },
            onLogoutConfirmed: function () {
                localStorage.removeItem('id');
                localStorage.removeItem('email');
                localStorage.removeItem('level');
                localStorage.removeItem('admin');
                localStorage.removeItem('password');
                Router.push('/admin');
            },
            showModal: function (title, message) {
                console.log("show modal " + title + " : " + message);
                this.$modal.show('dialog', {
                    title: title,
                    text: message,
                    buttons: [
                        {title: 'Close'}
                    ]
                })
                return;
            },
            keyHandler: function (key) {
                if (key == 'Enter') {
                    if (this.$data.inputList.length == 13) {
                        console.log("Barcode entered");
                        this.$data.barCode = this.$data.inputList.join('');
                        this.$data.content = '';
                        this.$data.editItem = false;
                        if (this.$data.barCode.startsWith("1")) {
                            this.$data.barCode = this.$data.barCode.substr(1);
                            var id = parseInt(this.$data.barCode);
                            console.log("Found id = " + id);
                            this.getItem(id);
                        } else {
                            this.getItemByAWB(this.$data.barCode);
                        }
                    } else {
                        console.log("Non barcode and entered");
                        // playWrongSound();
                    }
                    console.log("Remove now");
                    this.$data.inputList = [];

                    return;
                }
                if (parseInt(key) != NaN) {
                    //Add to
                    console.log("Number entered " + key);
                    this.$data.inputList.push(key);
                    if (this.$data.inputList.length > 13) {
                        console.log("Too long so remove");
                        this.$data.inputList = [];
                    }
                } else {
                    this.$data.inputList = [];
                    console.log("Non barcode input");
                }
            },
            showProgressView: function (msg) {
                console.log("showProgress");
                this.$data.progressMessage = msg;
                this.$data.showProgress = true;
            },
            dismissProgressView: function () {
                console.log("stopProgress");
                this.$data.showProgress = false;
            },
            getCustomerList: function () {
                var self = this;
                var url = process.env.APP_URL + 'api/get_customers.php?';
                axios.get(url)
                    .then(response => {
                        console.log("Get Customers");
                        console.log(response);

                        var data = response.data;
                        if (data.success == true) {
                            self.$data.customers = data.list.customer;
                            console.log(self.$data.customers);


                        } else {

                        }
                    })
                    .catch(error => {

                    });
            },
            startReader: function () {
                this.$data.manualCode = '';
                console.log("enableQrCodeReader");
                $("#qrReader").removeClass("hide");
                //this.$data.qrReaderOn = true;
                this.startScanner();
            },
            closeReader: function () {
                this.$data.qrReaderOn = false;
                if (!$("#qrReader").hasClass("hide")) {
                    $("#qrReader").addClass("hide");
                }
            },
            logIt (data) {
                console.log('detected ', data)
            },
            processed (result) {
                let drawingCtx = Quagga.canvas.ctx.overlay,
                    drawingCanvas = Quagga.canvas.dom.overlay;

                if (result) {
                    if (result.boxes) {
                        drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
                        result.boxes.filter(function (box) {
                            return box !== result.box;
                        }).forEach(function (box) {
                            Quagga.ImageDebug.drawPath(box, {x: 0, y: 1}, drawingCtx, {color: "green", lineWidth: 2});
                        });
                    }
                    if (result.box) {
                        Quagga.ImageDebug.drawPath(result.box, {x: 0, y: 1}, drawingCtx, {color: "#00F", lineWidth: 2});
                    }

                    if (result.codeResult && result.codeResult.code) {
                        Quagga.ImageDebug.drawPath(result.line, {x: 'x', y: 'y'}, drawingCtx, {color: 'red', lineWidth: 3});
                    }
                }
            },
            startScanner: function() {
                this.$data.workList = [];
                let self = this;
                Quagga.init({
                    inputStream : {
                        name : "Live",
                        type : "LiveStream",
                        target: this.$refs.quagga,    // Or '#yourElement' (optional)
                        constraints: {
                            width:375,
                            height:500,
                        }
                    },
                    decoder : {
                        readers : ["code_128_reader"],
                        debug: {
                            drawBoundingBox: false,
                        }
                    }
                }, function(err) {
                    if (err) {
                        console.log(err);
                        return
                    }
                    console.log("Initialization finished. Ready to start");
                    Quagga.onDetected(self.scannerProcessed)
                    Quagga.start();
                });
            },
            scannerProcessed: function(data) {
                console.log("scannerProcessed")
                console.log(data);
                if(data.codeResult != undefined && data.codeResult.code != undefined) {
                    if(this.$data.purposeWeight > 0 && data.codeResult.code === this.$data.barCode) {
                        console.log("Sames as last one")
                        return;
                    }
                    this.$data.barCode = data.codeResult.code;
                    this.getItemByAWB(this.$data.barCode);
                    if(this.$data.purposeWeight == 0) {
                        this.stopScanner();
                    }
                }

            },

            stopScanner: function() {
                Quagga.offDetected(this.onDetected)
                Quagga.stop();
                this.$refs.quagga.querySelector('video').remove()
                this.$refs.quagga.querySelector('canvas').remove()
                this.closeReader();
            },
            async onDecode(decodedString) {
                console.log("Decoded String " + decodedString);
                $("#qrReader").addClass("hide");
                var name = decodedString;//obj.name;
                this.$data.qrReaderOn = false;
                var id = parseInt(name);
                console.log("Found id = " + id);
                this.getItem(id);
            },
            onCodeEntered: function () {

                var self = this;
                $("#qrReader").addClass("hide");
                this.$data.qrReaderOn = false;
                var url = process.env.APP_URL + 'api/get_item.php?awb=' + this.$data.manualCode;
                axios.get(url)
                    .then(response => {
                        console.log("Get Customers");
                        console.log(response);

                        var data = response.data;
                        if (data.success == true) {
                            self.$data.editItem = data.item;
                            //console.log(self.$data.customers);
                            if(self.$data.purposeWeight > 0) {
                                self.applyPurposeWeight();
                            }

                        } else {
                            console.log(data.message);
                        }
                    })
                    .catch(error => {

                    });
            },
            getItemByAWB: function (awb) {
                let self = this;
                let url = process.env.APP_URL + 'api/get_item.php?awb=' + awb;
                axios.get(url)
                    .then(response => {
                        console.log("Get Item with AWB");
                        console.log(response);

                        var data = response.data;
                        if (data.success == true) {
                            let today = millisToDate(new Date().getTime(), '-');
                            let tomorrow = millisToDate(new Date().getTime() + (24*60*60*1000), '-');
                            console.log("check dispatch date " + data.item.dispatch_date + " is if " + today + " or " + tomorrow);
                            if(data.item.dispatch_date !== today && data.item.dispatch_date !== tomorrow) {
                              self.showModal("보내는 날짜가 오늘 또는 내일 날짜가 아닙니다.");
                              playWrongSound();

                              return;
                            }
                            data.item.measured_weight = data.item.measured_weight/100.0;
                            self.$data.editItem = data.item;
                            playSound();

                            if (data.item.list == '') {
                                self.$data.editItem.list = [];
                            } else {
                                self.$data.editItem.list = JSON.parse(data.item.list);
                            }
                            if(self.$data.purposeWeight > 0) {
                                self.applyPurposeWeight();
                                // self.$data.workList.push(data.item.awb);
                            }
                            //console.log(self.$data.customers);


                        } else if (data.success == false && data.item == false) {
                            console.log("wrong sound 1");
                            playWrongSound()
                            console.log(data.message);
                            //self.getTracking(awb);
                            self.showModal("송장: " + awb, "찾을수 없습니다.");

                        }
                    })
                    .catch(error => {
                      console.log("wrong sound 2")
                      playWrongSound();
                    });
            },
            getItem: function (id) {
                var self = this;
                var url = process.env.APP_URL + 'api/get_item.php?id=' + id;
                axios.get(url)
                    .then(response => {
                        console.log("Get Customers");
                        console.log(response);

                        var data = response.data;
                        if (data.success == true) {
                            data.item.measured_weight = data.item.measured_weight/100.0;
                            self.$data.editItem = data.item;
                            //console.log(self.$data.customers);


                        } else {
                            console.log(data.message);
                        }
                    })
                    .catch(error => {

                    });
            },
            onVolumeEntered: function () {
                this.$data.editItem.volume_weight = this.$data.editItem.volume_x * this.$data.editItem.volume_y * this.$data.editItem.volume_z / 6000;
                this.$data.editItem.volume_weight = parseFloat(this.$data.editItem.volume_weight).toFixed(2) * 100;
                console.log("Scaled Weight " + this.$data.editItem.measured_weight);
                console.log("Volume Weight " + this.$data.editItem.volume_weight);
                this.$data.editItem.weight = this.$data.editItem.volume_weight > this.$data.editItem.measured_weight*100 ? this.$data.editItem.volume_weight : this.$data.editItem.measured_weight*100;
                console.log("Weight " + this.$data.editItem.weight);
                if (this.$data.editItem.weight <= 100) {
                    this.$data.editItem.price = this.$data.editItem.base_price;
                } else {
                    var extra = this.$data.editItem.weight - 100;
                    var extraUnit = parseInt(extra / 50);
                    if (extra % 50 >= 10) {
                        extraUnit += 1;
                    }
                    console.log("extra " + extraUnit);
                    this.$data.editItem.price = Number(this.$data.editItem.base_price) + Number(extraUnit) * Number(this.$data.editItem.add_price);
                }

            },
            closeItem: function () {
                this.$data.editItem = false;
            },
            getNow: function () {
                var myDate = new Date();
                var month = ('0' + (myDate.getMonth() + 1)).slice(-2);
                var date = ('0' + myDate.getDate()).slice(-2);
                var year = myDate.getFullYear();
                var hour = ('0' + (myDate.getHours())).slice(-2);
                var minute = ('0' + (myDate.getMinutes())).slice(-2);
                var seconds = ('0' + (myDate.getSeconds())).slice(-2);
                var formattedDate = year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + seconds;
                return formattedDate;
            },
            getDistance: function () {
                // this.getVolume();
                //this.getDistanceZ();
                // this.getDistanceX();
                this.getDistanceXR();
                this.getDistanceY();
                this.getDistanceZ();
                this.getWeight();
            },
            getVolume: function () {
                var self = this;
                axios.get('https://utasco.eu.ngrok.io/getXYZ.php')
                //axios.get('https://5e655c52.ngrok.io/measure.php')
                    .then(response => {
                        console.log(response.data);
                        if (response.data != undefined) {
                            self.$data.editItem.volume_x = Math.round(response.data.volume_x);
                            self.$data.editItem.volume_y = Math.round(response.data.volume_y);
                            self.$data.editItem.volume_z = Math.round(response.data.volume_z);
                            self.onVolumeEntered();

                        }
                    })
                    .catch(error => {
                        console.log("Getting volume error " + error);
                    })
            },
            // getDistanceX: function () {
            //     var self = this;
            //     axios.get('http://10.0.1.13/measure.php')
            //     //axios.get('https://5e655c52.ngrok.io/measure.php')
            //         .then(response => {
            //             console.log(response.data);
            //             if (response.data != undefined && response.data.length > 0) {
            //
            //                 if (response.data.startsWith("Distance:") && response.data.endsWith("cm")) {
            //                     var words = response.data.replace(" ", "").replace("Distance:", "").replace("cm", "");
            //                     var fn = parseFloat(words);
            //                     var intD = 52 - Math.round(fn);
            //                     console.log("Distance : " + fn);
            //                     self.$data.editItem.volume_x = intD;
            //                     self.$data.editItem.volume_y = intD;
            //                     self.onVolumeEntered();
            //                 } else {
            //
            //                 }
            //                 //self.getWeight();
            //             }
            //         })
            //         .catch(error => {
            //             console.log("Getting weight error " + error);
            //         })
            // },
            // getDistanceX: function () {
            //     var self = this;
            //     //axios.get('http://10.0.1.13/measure.php')
            //     axios.get('https://utasco.ngrok.io/measure.php')
            //         .then(response => {
            //             console.log(response.data);
            //             if (response.data != undefined && response.data.length > 0) {
            //                 if (response.data.startsWith("Distance:") && response.data.endsWith("cm")) {
            //                     var words = response.data.replace(" ", "").replace("Distance:", "").replace("cm", "");
            //                     var fn = parseFloat(words);
            //                     var intD = 52 - Math.round(fn);
            //                     console.log("Distance : " + fn);
            //                     self.$data.editItem.volume_x = intD;
            //                     self.$data.editItem.volume_y = intD;
            //                     self.onVolumeEntered();
            //                 } else {
            //
            //                 }
            //                 //self.getWeight();
            //             }
            //         })
            //         .catch(error => {
            //             console.log("Getting weight error " + error);
            //         })
            // },

            getDistanceX: function () {
                var self = this;
                axios.get("https://utasco.eu.ngrok.io/getX.php")
                //axios.get('https://5e789e4a.ngrok.io/measure.php')
                    .then(response => {
                        console.log(response.data);
                        if (response.data != undefined) {
                            let data = response.data;
                            if (data.x != undefined) {
                                self.$data.size.x = Math.round(data.x);
                                self.calculateVolume();
                            }

                        }
                    })
                    .catch(error => {
                        console.log("Getting weight error " + error);
                    })

            },
            getDistanceXR: function () {
                var self = this;
                axios.get("https://utasco.eu.ngrok.io/getXR.php")
                //axios.get('https://5e789e4a.ngrok.io/measure.php')
                    .then(response => {
                        console.log(response.data);
                        if (response.data != undefined) {
                            let data = response.data;
                            if (data.xr != undefined) {
                                self.$data.size.xr = Math.round(data.xr);
                                self.calculateVolume();
                            }

                        }
                    })
                    .catch(error => {
                        console.log("Getting weight error " + error);
                    })

            },
            getDistanceY: function () {
                var self = this;
                axios.get("https://utasco.eu.ngrok.io/getY.php")
                //axios.get('https://5e789e4a.ngrok.io/measure.php')
                    .then(response => {
                        console.log(response.data);
                        if (response.data != undefined) {
                            let data = response.data;
                            if (data.y != undefined) {
                                self.$data.size.y = Math.round(data.y);
                                self.calculateVolume();
                            }

                        }
                    })
                    .catch(error => {
                        console.log("Getting weight error " + error);
                    })

            },
            getDistanceZ: function () {
                var self = this;
                axios.get("https://utasco.eu.ngrok.io/getZ.php")
                //axios.get('https://5e789e4a.ngrok.io/measure.php')
                    .then(response => {
                        console.log(response.data);
                        if (response.data != undefined) {
                            let data = response.data;
                            if (data.z != undefined) {
                                self.$data.size.z = Math.round(data.z);
                                self.calculateVolume();
                            }

                        }
                    })
                    .catch(error => {
                        console.log("Getting weight error " + error);
                    })

            },
            getWeightKeepVolume:function(){
                var self = this;
                axios.get('https://utasco.eu.ngrok.io/get_weight.php')
                    .then(response => {
                        console.log(response.data);
                        if (response.data != undefined && response.data.length > 0) {
                            if (response.data.startsWith("W:+")) {
                                //var words = response.data.replace(" ", "").replace("W:+", "").replace("kg", "").replace(".", "");
                                var words = response.data.replace(" ", "").replace("W:+", "").replace("kg", "");//.replace(".", "");
                                console.log(words);
                                self.$data.editItem.measured_weight = parseFloat(words);
                                this.$data.editItem.volume_x = Math.round(100 - this.$data.size.xr);//Math.round(100 - this.$data.size.x + 1 - this.$data.size.xr + 1);
                                this.$data.editItem.volume_y = Math.round(51.5 - this.$data.size.y);
                                this.$data.editItem.volume_z = Math.round(69 - this.$data.size.z);
                                self.onVolumeEntered();
                            } else {

                            }
                        }
                    })
                    .catch(error => {
                        console.log("Getting weight error " + error);
                    })
            },
            calculateVolume: function () {
                console.log("Calculate volumne");
                console.log(this.$data.size);
                this.$data.editItem.volume_x = Math.round(99-this.$data.size.xr);// Math.round(100 - this.$data.size.x + 1 - this.$data.size.xr + 1);
                this.$data.editItem.volume_y = Math.round(51.5 - this.$data.size.y);
                this.$data.editItem.volume_z = Math.round(59 - this.$data.size.z);
                this.onVolumeEntered()
            },
            getWeight: function () {
                var self = this;
                //axios.get('http://10.0.1.13/get_weight.php')
                axios.get('https://utasco.eu.ngrok.io/get_weight.php')
                    .then(response => {
                        console.log(response.data);
                        if (response.data != undefined && response.data.length > 0) {
                            if (response.data.startsWith("W:+")) {
                                // var words = response.data.replace(" ", "").replace("W:+", "").replace("kg", "").replace(".", "");
                                var words = response.data.replace(" ", "").replace("W:+", "").replace("kg", "");//.replace(".", "");
                                console.log(words);
                                self.$data.editItem.measured_weight = parseFloat(words);
                                self.onVolumeEntered();
                            } else {

                            }
                        }
                    })
                    .catch(error => {
                        console.log("Getting weight error " + error);
                    })
            },
            applyPurposeWeight:function() {

                if(this.$data.purposeWeight == 0) {
                    return;
                }
                this.$data.editItem.measured_weight = parseFloat(this.$data.purposeWeight);

                this.$data.editItem.weight = this.$data.editItem.volume_weight > this.$data.editItem.measured_weight*100 ? this.$data.editItem.volume_weight : this.$data.editItem.measured_weight*100;
                console.log("Weight " + this.$data.editItem.weight);
                if (this.$data.editItem.weight <= 100) {
                    this.$data.editItem.price = this.$data.editItem.base_price;
                } else {
                    var extra = this.$data.editItem.weight - 100;
                    var extraUnit = parseInt(extra / 50);
                    if (extra % 50 > 0) {
                        extraUnit += 1;
                    }
                    console.log("extra " + extraUnit);
                    this.$data.editItem.price = Number(this.$data.editItem.base_price) + Number(extraUnit) * Number(this.$data.editItem.add_price);

                }
                setTimeout(this.updateItem(), 500);
            },
            updateItem: function () {
                if (this.$data.editItem == false) {
                    return;
                }

                var data = {
                    id: this.$data.editItem.id,
                    volume_x: this.$data.editItem.volume_x,
                    volume_y: this.$data.editItem.volume_y,
                    volume_z: this.$data.editItem.volume_z,
                    volume_weight: this.$data.editItem.volume_weight,
                    measured_weight: this.$data.editItem.measured_weight*100,
                    weight: this.$data.editItem.weight,
                    base_price: this.$data.editItem.base_price,
                    add_price: this.$data.editItem.add_price,
                    price: this.$data.editItem.price,
                };
                if (this.$data.editItem.price > 0
                    && this.$data.editItem.weight > 0 && this.$data.editItem.state == 0) {
                    data["state"] = 1;
                    data["in_time"] = this.getNow();
                }
                var postData = {
                    "table": "item_table",
                    "data": data,
                };
                var self = this;
                axios.post(process.env.APP_URL + 'api/update.php', postData)
                    .then(response => {

                        console.log(response);
                        var data = response.data;
                        if (data.success == true) {
                            console.log("Successful update");
                            if(self.$data.workList.length > 0) {
                                for(let i = 0 ; i < self.$data.workList.length ; i++) {
                                    if(self.$data.workList[i].id == data.item.id) {
                                        self.$data.workList.splice(i, 1);
                                        break;
                                    }
                                }
                            }
                            self.$data.workList.unshift(data.item);
                            self.$data.editItem = false;
                            self.addTodayItem(data.item.awb);
                            playSound();
                        } else {
                            //self.showModal("ERROR", "Failed to update " + data.message);
                          console.log("wrong sound 3");
                          playWrongSound()
                        }
                    })
                    .catch(error => {
                      console.log("wrong sound 4");
                      playWrongSound();

                    })
            },
            printItem: function () {
                console.log("printItem");
                let zipCode = this.$data.editItem.post_code;
                let address = this.$data.editItem.address_1;
                if (this.$data.editItem.address_2.length > 0) {
                    address += ' ' + this.$data.editItem.address_2;
                }
                console.log("printItem zipCode = " + zipCode);
                console.log("printItem address = " + address);

                let self = this;
                this.$data.isLoading = true;
                getDepotCode(zipCode, address)
                    .then(function (data) {
                        self.$data.isLoading = false;
                        console.log("getDepotCode Response");
                        console.log(data);
                        if (data.cmmMsgHeader.successYN == 'Y') {
                            self.printLabel(data.delivAreaCdList, self.$data.editItem.ct);
                        }

                    })
                    .catch(function (err) {
                        self.$data.isLoading = false;
                        console.log(err);
                    })
            },
            printLabel: function (cdList, count) {
                let self = this;
                self.$data.isLoading = true;
                let extra = "수량 " + this.$data.editItem.ct + "-" + count;
                requestPrintLabel(cdList, this.$data.editItem, extra)
                    .then(function (response) {
                        self.$data.isLoading = false;
                        let newCount = count -1;
                        if(newCount > 0) {
                            self.printLabel(cdList, newCount);
                            return;
                        }
                    })
                    .catch(function (err) {
                        self.$data.isLoading = false;
                    })
            },
        }
    }
</script>
<style>
  .camera, .pause-frame {
    max-height: 500px;
  }
  .fix-qr-code {
    width: 200px;
  }
  .panel-container {
    height: calc(100% - 60px);
  }
</style>



// WEBPACK FOOTER //
// src/components/CheckIn.vue